import { WorkflowItem } from "./workflow-item.model";
import { BaseModel } from "../base.model";

export class WorkflowConnection extends BaseModel{         
    Source: WorkflowItem
    Target: WorkflowItem        
    
    constructor(type:string, source: WorkflowItem, target: WorkflowItem, version: string, id: number){
        super();
        this.$type = type;
        this.Source = source;
        this.Target = target;
        this.Version = version;
        this.Id = id;
    }

}



